// SSC Collection Page — Variant Dropdown + Filter Logic
function sscVariantChange(selectEl) {
  const selectedOption = selectEl.options[selectEl.selectedIndex];
  const card = selectEl.closest('.card__information');
  if (!card) return;
  const priceEl = card.querySelector('.price__regular .price-item--regular');
  const compareEl = card.querySelector('.price__sale .price-item--regular');
  if (priceEl) priceEl.textContent = selectedOption.dataset.price;
  if (compareEl && selectedOption.dataset.compare) {
    compareEl.textContent = selectedOption.dataset.compare;
  }
  const atcBtn = card.closest('.card-wrapper')?.querySelector('[data-variant-id]');
  if (atcBtn) atcBtn.dataset.variantId = selectEl.value;
}